import BaseService from '../base-service';
import { PersonalKey } from './personal-key.model';

export default class PersonalKeysService extends BaseService<PersonalKey> {
  get endpoint() {
    return 'personal-keys';
  }
}
